export type Domain = {
  DEV: string;
  UAT: string;
  PROD: string;
  title: string;
  sessionLogoutUrl?: string;
  logoutPathname: string;
};

type DomainList = Domain[];

const domainList: DomainList = [
  {
    DEV: "http://localhost:3001/",
    UAT: "https://swms.prozo.com/",
    PROD: "https://wms.prozo.com/",
    title: "WMS & OMS",
    sessionLogoutUrl: `${process.env.REACT_APP_WMS_ENDPOINT_V1}session/close/all/{{userId}}`,
    logoutPathname: "oauth/logout",
  },
  /* {
    DEV: "https://ct.prozo.com",
    UAT: "https://ct.prozo.com",
    PROD: "https://ct.prozo.com",
    title: "Control Tower",
  },

  {
    DEV: "https://www.proship.in",
    UAT: "https://www.proship.in",
    PROD: "https://www.proship.in",
    title: "Proship Merchant",
  }, */
];

export default domainList;
